<div class="templat-container">
  <div class="app__discovery--header--search--field  mb-[20px] bg-[#FFFFFF]">
    <div class="app__centered-item w-full h-full px-5">
      <span> <img src="../../../../../../assets/images/search-icon.svg" /> </span>
      <input class="text-box-custom px-3" autocomplete="off" placeholder="Search Users" #search type="text" [formControl]="searchString" />
       @if (searchString) {
      <span
        (click)="clearSearchAction()"
      class="material-icons relative bg-white text-[#898F9E] text-2xl hover:cursor-pointer">clear</span>
    }
  </div>
</div>
<div style="height: 200px;  overflow-x: hidden !important; overflow: auto">
  @if (
    clientGroups.length || !searchString?.value || ownerUserProfile?.name?.toLowerCase().indexOf(searchString?.value?.toLowerCase()) >= 0) {
    <span
      class="static-cards-wrapper"
      >
      @if ((!searchString?.value || ownerUserProfile?.name?.toLowerCase().indexOf(searchString?.value?.toLowerCase()) >= 0) && !connectedUserinPolicy && clientGroups.length) {
        <div
          class="static-cards"
          >
          <div
            class="header-body"
            [ngStyle]="{ cursor: 'pointer' }"
            (click)="$event.stopPropagation(); addLoginUser()"
            >
            <div class="child-container">
              <ngx-avatars
                size="24"
                [src]="ownerUserProfile.image"
                [name]="ownerUserProfile.name"
                [round]="false"
                initialsSize="2"
                cornerRadius="100"
              ></ngx-avatars>
              <p>{{ ownerUserProfile.name | truncateStrPipe : 28 }}</p>
            </div>
          </div>
        </div>
      }
      @if (clientGroups) {
        <div>
          @for (item of clientGroups; track item; let i = $index) {
            @if (item.user_id != ownerUserProfile.id) {
              <div class="static-cards">
                <div
                  class="header-body"
                  [ngStyle]="{ cursor: 'pointer' }"
                  (click)="$event.stopPropagation(); openFolder(item, i)"
                  >
                  <div class="child-container">
                    <ngx-avatars
                      size="24"
                      [src]="item.user_profile_image_url"
                      [name]="item.user_first_middle_name + ' ' + item.user_last_name"
                      [round]="false"
                      initialsSize="2"
                      cornerRadius="100"
                    ></ngx-avatars>
                    <p>{{ item.user_first_middle_name + ' ' + item.user_last_name | truncateStrPipe : 28 }}</p>
                  </div>
                  @if (item.isRunning) {
                    <div class="child-container" style="padding-right: 12px">
                      <p class="checking-permission" style="margin-right: 9px">Checking permission ...</p>
                    </div>
                  }
                </div>
                <div class="flex bg-[#EAF0F7] justify-between " *ngIf="selectedUserIndex === i" style="margin-left: -16px;text-align: center; margin-bottom: 10px;">
                @if (!item.isAccess) {
                  <div class="message-body">
                    <p class="message-text">
                      {{ item.user_first_middle_name + ' ' + item.user_last_name }} needs permission to access the attached template.
                    </p>
                  </div>
                }
                @if (!item.isAccess) {
                  <div class="action-body">
                    <button
                      (click)="$event.stopPropagation(); item.isAccess = true; item.isRunning = false"
                      class="Cancel-btn"
                      mat-button
                      [disableRipple]="true"
                      >
                      Cancel
                    </button>
                    <button (click)="$event.stopPropagation(); grantPermission(item, i)" class="give-permission-btn" [disableRipple]="true" mat-button>
                      Share
                    </button>
                  </div>
                }
              </div>
              </div>
            }
          }
        </div>
      }
      @if (entitiesItems) {
        <div>
          @for (item of entitiesItems; track item; let i = $index) {
            <div class="static-cards">
              <div class="header-body cursor-pointer" (click)="$event.stopPropagation(); addVaultForm(item, i)">
                <div class="child-container">
                  <ngx-avatars
                    size="24"
                    [src]="item.profile_image_url"
                    [name]="item.form_name"
                    [round]="false"
                    initialsSize="2"
                    cornerRadius="100"
                  ></ngx-avatars>
                  <p>{{ item.form_name | truncateStrPipe : 38 }}</p>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </span>
  } @else {
    <p style="padding-left: 16px">No Result Found</p>
  }
</div>
</div>
